module.exports = __webpack_public_path__ + "img/rocketship-3.35ef9bf5.webp";